import { ModalHeaderRow } from '@components/modal/ModalHeaderRow';
import { Flex } from '@endurancewarranty/ui';

import type { FC, ReactNode } from 'react';

type Props = Readonly<{
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}>;

export const ModalContent: FC<Props> = ({ children, footer, header }) => {
  const footerBuffer = footer != null ? <Flex className="h-16"></Flex> : undefined;

  return (
    <Flex className={'h-full'} direction="col" onClick={(e) => e.stopPropagation()}>
      {header != null && <ModalHeaderRow>{header}</ModalHeaderRow>}
      <div className="scrollbar grow overflow-auto pr-1 pb-1">
        {children}
        {footerBuffer}
      </div>
      {footer}
    </Flex>
  );
};
